// Semantic one-off inks, routed through tokens(paletteId).
const utilColors = (colors) => ({
  white: colors.surface,
  oliveGreen: colors.okText,
  bloodRed: colors.errText,
  skyBlue: colors.link,
});

export default utilColors;
